import {LocateDto} from "../api";

export function locateDtoToList(locateDto: LocateDto): LocateDto[] {
    const locateDtos = locateDtoToListWithChild(locateDto); // Holt die Liste der verschachtelten locateDtos


    // Durchlaufe jedes locateDto und setze .locate auf undefined
    /*
    const locateDtos1 = locateDtos.map(dto => {
        dto.locate = undefined;
        return dto;
    });*/
    return locateDtos;
}

function locateDtoToListWithChild(locateDto: LocateDto): LocateDto[] {
    if (!locateDto) {
        return [];
    }

    // Starten mit der Liste, die das aktuelle Element enthält
    const list = [locateDto];

    // Wenn das aktuelle locateDto Kinder hat, rufen wir die Funktion rekursiv auf
    if (locateDto.locate) {
        const childList = locateDtoToList(locateDto.locate);
        list.push(...childList); // Alle Kinder zur Liste hinzufügen
    }

    return list;
}

// Diese Funktion konvertiert eine Liste von Locates zurück in ein verschachteltes LocateDto.
export function listToLocateDto(list) {
    if (!list || list.length === 0) {
        return null;
    }

    const parent = list[0]; // Das erste Element in der Liste ist der Parent
    const children = list.slice(1); // Alle anderen Elemente sind Kinder

    // Rekursive Funktion zum Hinzufügen der Kinder
    const assignChildren = (parent, children) => {
        if (children.length === 0) {
            return;
        }

        // Das erste Kind wird dem parent hinzugefügt
        parent.locate = children[0];
        // Rufen Sie die Funktion rekursiv für das nächste Kind auf
        assignChildren(parent.locate, children.slice(1));
    };

    assignChildren(parent, children);

    return parent;
}
